import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import component from './component';
import userQuery from './userQuery.graphql';

const mapGraphqlToProps = ({ data: { user, loading } }) => ({ user, loading });

export default withRouter(graphql(userQuery, { props: mapGraphqlToProps })(component));



// WEBPACK FOOTER //
// ./src/components/App/container.js